import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import SlugValidator from "../navigableValidators/slugValidator";
import NavigableValidation from "./navigableValidation";
import FormDetailSeo from "../../../formability/form_builder/models/formDetails/formDetailSeo";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class FormDetailSeoValidation extends NavigableValidation<FormDetailSeo> {
  validators = [
    new FieldPresenceValidator({
      validatorKey: 'title',
      section: ValidationModalSection.PublicProfile
    }),
    new SlugValidator({
      validatorKey: 'slug',
      section: ValidationModalSection.PublicProfile
    })
  ];
}